const GoogleApiPolygon = data => {
    if (data.startsWith("MULTIPOLYGON")) {
        let coordinatesRaw = data.substring(
            data.indexOf("(") + 2,
            data.lastIndexOf(")") - 1
        );
        let coordinatesArr = coordinatesRaw.split(")");
        coordinatesArr = coordinatesArr.map(item => {
            return item.substring(item.indexOf("(") + 1, item.length);
        });
        delete coordinatesArr[coordinatesArr.length - 1];
        coordinatesArr = coordinatesArr.filter(item => item);
        coordinatesArr = coordinatesArr.map(item => {
            let items = item.split(",");
            items = items.map(item => {
                item = item.split(" ");
                return {
                    lat: parseFloat(item[1]),
                    lng: parseFloat(item[0])
                };
            });
            return items;
        });
        return coordinatesArr;
    } else {
        let coordinatesRaw = data.substring(
            data.lastIndexOf("(") + 1,
            data.indexOf(")")
        );
        let coordinatesInArray = coordinatesRaw.split(",");
        let polygonArray = [];
        for (let i = 0; i < coordinatesInArray.length; i++) {
            let coordinatesSeperate = coordinatesInArray[i].split(" ");
            let [long, lat] = coordinatesSeperate;
            let myvar = {
                lat: parseFloat(lat),
                lng: parseFloat(long)
            };
            polygonArray.push(myvar);
        }
        return [polygonArray];
    }
}

export default GoogleApiPolygon;